/**
 * Registro de sessões ativas por aba.
 *
 * Cada instância de useSession registra um "closer" aqui ao montar.
 * O logout chama closeAllRegisteredSessions() ANTES do firebase.auth().signOut(),
 * garantindo que as sessões sejam encerradas enquanto o token ainda é válido.
 *
 * O registro é por aba (module-level singleton dentro do contexto JS de cada aba).
 */
type SessionCloser = () => Promise<void>;

const registry = new Map<string, SessionCloser>();

export function registerSessionCloser(key: string, closer: SessionCloser): () => void {
  registry.set(key, closer);
  return () => registry.delete(key);
}

export async function closeAllRegisteredSessions(): Promise<void> {
  const closers = Array.from(registry.values());
  registry.clear();
  await Promise.allSettled(closers.map((fn) => fn()));
}
